module.exports = __webpack_public_path__ + "static/media/logout-gray.30147c97.svg";